import { atom } from 'jotai'

export const rewardsDetailsBreadcrumbAtom = atom<string>('')
rewardsDetailsBreadcrumbAtom.debugLabel = 'rewards-details-breadcrumb'
